export function formatMoney(value) {
  const num = Number(value);
  if (Math.abs(num) >= 1_000_000) {
    return (
      (num / 1_000_000).toLocaleString("ru-RU", {
        maximumFractionDigits: 1,
      }) + " млн ₽"
    );
  }
  if (Math.abs(num) >= 1_000) {
    return (
      (num / 1_000).toLocaleString("ru-RU", {
        maximumFractionDigits: 1,
      }) + " тыс. ₽"
    );
  }
  return (
    num.toLocaleString("ru-RU", { maximumFractionDigits: 2 }) + " ₽"
  );
}

export function formatChartValue(value, mode) {
  const num = Number(value);
  if (mode === "axis") {
    if (Math.abs(num) >= 1_000_000)
      return (num / 1_000_000).toFixed(1) + "М";
    if (Math.abs(num) >= 1_000) return (num / 1_000).toFixed(0) + "К";
    return Math.round(num).toString();
  }
  return formatMoney(value);
}

export function formatDisplayDate(start, end) {
  const [, sm, sd] = start.split("-");
  if (start === end) return `${sd}.${sm}`;
  const [, em, ed] = end.split("-");
  return `${sd}.${sm}–${ed}.${em}`;
}

export function barWidth(value, max) {
  if (!max) return 0;
  return Math.min(
    Math.round((Math.abs(value) / Math.abs(max)) * 100),
    100
  );
}
